var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceActionsEdit = function SvgInterfaceActionsEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.414 2a1 1 0 0 0-.707.293l-2 2-1.414 1.414L3 17v4h4L21.707 6.293a1 1 0 0 0 0-1.414l-2.586-2.586A1 1 0 0 0 18.414 2m0 2.414 1.172 1.172-1.293 1.293-1.172-1.172zm-2.707 2.707 1.172 1.172L6.172 19H5v-1.172z"
  })));
};
export default SvgInterfaceActionsEdit;